module.exports = __webpack_public_path__ + "static/img/store-label-intro.5fdc2179.png";